import type { CustomQuestionnaireAnswersPayload } from '../../../../api/customQuestionnaire'
import type {
	FormikValues,
	QuestionDefinition,
	UploadedFileMetadata,
} from '../../types'

import { mapToApiAnswers } from './toCustomQuestionnaireAnswersApiMapping'

export { uploadDocuments } from './documents'
export type { DocumentUploads } from './documents'

export const convertToAnswerPayload = (
	values: FormikValues,
	questions: QuestionDefinition[],
	currency: string,
	questionnaireVersionId: number,
	documentUploads?: Record<string, UploadedFileMetadata[]>,
): CustomQuestionnaireAnswersPayload => {
	return {
		answers: mapToApiAnswers(values, questions, currency, documentUploads),
		questionnaireVersionId,
	}
}
